export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-teal-600 text-white py-20">
      <div className="max-w-7xl mx-auto px-12">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-12 mb-16">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/b60d1f3b-f8c0-42f8-b4f1-6f9e6cdf9522.png" 
                alt="CONSTRUTORA MANUELLA LTDA" 
                className="h-10 w-10 object-contain"
              />
              <span className="text-xl font-bold">CONSTRUTORA MANUELLA LTDA</span>
            </div>
            <p className="text-teal-100 mb-10 max-w-md">
              Your trusted partner in digital privacy
            </p>

            <div className="grid grid-cols-3 gap-8">
              <div>
                <h4 className="font-semibold mb-4">Product</h4>
                <ul className="space-y-3">
                  <li>
                    <button onClick={() => scrollToSection('features')} className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                      Features
                    </button>
                  </li>
                  <li>
                    <button onClick={() => scrollToSection('security')} className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                      Security
                    </button>
                  </li>
                  <li>
                    <button onClick={() => scrollToSection('how-it-works')} className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                      Servers
                    </button>
                  </li>
                </ul>
              </div>

              <div>
                <h4 className="font-semibold mb-4">Company</h4>
                <ul className="space-y-3">
                  <li>
                    <button onClick={() => scrollToSection('about')} className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                      About
                    </button>
                  </li>
                  <li>
                    <button onClick={() => scrollToSection('contact')} className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                      Contact
                    </button>
                  </li>
                  <li>
                    <button onClick={() => scrollToSection('contact')} className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                      Support
                    </button>
                  </li>
                </ul>
              </div>

              <div>
                <h4 className="font-semibold mb-4">Legal</h4>
                <ul className="space-y-3">
                  <li>
                    <a href="#" className="text-teal-100 hover:text-white transition-colors text-sm">
                      Privacy Policy
                    </a>
                  </li>
                  <li>
                    <a href="#" className="text-teal-100 hover:text-white transition-colors text-sm">
                      Terms of Service
                    </a>
                  </li>
                  <li>
                    <a href="#" className="text-teal-100 hover:text-white transition-colors text-sm">
                      Cookie Policy
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-xl font-semibold mb-6">Stay Updated</h4>
            <div className="flex gap-0 max-w-md">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 h-14 px-5 bg-teal-700 border border-teal-500 rounded-l-2xl text-sm text-white placeholder-teal-300 focus:outline-none focus:border-cyan-400"
              />
              <button className="bg-cyan-500 text-white px-8 h-14 rounded-r-2xl font-semibold hover:bg-cyan-600 transition-all whitespace-nowrap cursor-pointer">
                Subscribe
              </button>
            </div>
          </div>
        </div>

        <div className="border-t border-teal-500 pt-8 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-sm text-teal-100">
            © 2025 CONSTRUTORA MANUELLA LTDA. All rights reserved
          </p>

          <div className="flex items-center gap-6">
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-sm text-teal-100 hover:text-white transition-colors"
            >
              Powered by Readdy
            </a>
            <div className="flex items-center gap-5">
              <a href="#" className="w-5 h-5 flex items-center justify-center text-teal-100 hover:text-cyan-400 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="w-5 h-5 flex items-center justify-center text-teal-100 hover:text-cyan-400 transition-colors cursor-pointer">
                <i className="ri-twitter-x-fill text-xl"></i>
              </a>
              <a href="#" className="w-5 h-5 flex items-center justify-center text-teal-100 hover:text-cyan-400 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="w-5 h-5 flex items-center justify-center text-teal-100 hover:text-cyan-400 transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-xl"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
